import { getFileExtension } from './fileTypeDetection';
import { ValidationResult, SupportedExt, FileInput } from './types';
import { validateImage } from './validators/validateImage';
import { validatePdf } from './validators/validatePdf';
import { validatePpt } from './validators/validatePpt';
import { validatePptx } from './validators/validatePptx';
import { validateZip } from './validators/validateZip';

const validators: Record<SupportedExt, (input: FileInput) => Promise<ValidationResult>> = {
  pdf: validatePdf,
  ppt: validatePpt,
  pptx: validatePptx,
  zip: validateZip,
  jpg: validateImage,
  jpeg: validateImage,
  png: validateImage,
  gif: validateImage,
  webp: validateImage,
};

export async function validateFile(file: File): Promise<ValidationResult> {
  const ext = getFileExtension(file.name);
  const validator = validators[ext as SupportedExt];

  if (!validator) return { valid: true, skipped: true };
  return validator(file);
}

export type { ValidationResult };
export { validateAndListZip } from './validateAndListZip';
export type { ValidateAndListResult, ZipFileMetadata } from './validateAndListZip';
